import CircularProgress from '@mui/material/CircularProgress'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

interface ILoadingUIProps {
  title?: React.ReactNode
}

const LoadingUIView = (props: ILoadingUIProps) => {
  return (
    <Stack paddingTop='40vh' alignItems='center'>
      <CircularProgress />

      <Typography variant='h5' fontWeight='bold'>
        {props.title}
      </Typography>
    </Stack>
  )
}

export default LoadingUIView
